import { isValid, parseISO } from 'date-fns';

// True only when a real, parseable date is present. Used to hide date-dependent
// UI (e.g. the "Since" line) entirely rather than render "Missing data", which
// reads like a bug. Some cohorts (e.g. Bench Maji) have no registration_date.
export const isValidDate = (dateString: string | undefined | null): boolean =>
  !!dateString && isValid(parseISO(dateString));

export const formatDate = (dateString: string | undefined): string => {
  if (!isValidDate(dateString)) {
    return 'Missing data';
  }
  // Date-only display (YYYY-MM-DD), e.g. "Since 2021-08-11". Slice the string
  // rather than reformat through a Date object, so a date-only value like
  // "2021-08-11Z" can't shift by a day due to timezone conversion.
  return (dateString as string).slice(0, 10);
};
